import {
  fetchCustomerContractsRequest,
  fetchSingleCustomerContractRequest,
  upsertCustomerContractRequest,
} from 'actions/customerContracts';
import { CustomerContract, Selector } from 'types';

export const getCustomerContract: Selector<CustomerContract | null> = (state) =>
  state.customerContracts.activeContract;

export const getCustomerContracts: Selector<CustomerContract[]> = (state) =>
  state.customerContracts.contracts;
export const getCustomerContractsTotalCount: Selector<number> = (state) =>
  state.customerContracts.customerContractsCount;
export const getCustomerContractsLoading: Selector<boolean> = (state) =>
  state.customerContracts.loading.includes(fetchCustomerContractsRequest.toString());

export const getSingleCustomerContractLoading: Selector<boolean> = (state) =>
  state.customerContracts.loading.includes(fetchSingleCustomerContractRequest.toString());

export const getUpsertCustomerContractLoading: Selector<boolean> = (state) =>
  state.customerContracts.loading.includes(upsertCustomerContractRequest.toString());
